import React, { useState, createContext } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Index from "./pages/Index";
import Saved from "./pages/Saved";
import useLocalStorage from "./hooks/useLocalStorage";

export const SavedContext = createContext({});

function SavedContextProvider(props) {
  const [saved, setSaved] = useLocalStorage("saved", []);
  return <SavedContext.Provider value={{ saved, setSaved }} {...props} />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <SavedContextProvider>
          <Routes>
            <Route exact path="/" element={<Index />} />
            <Route path="/saved" element={<Saved />} />
          </Routes>
        </SavedContextProvider>
      </div>
    </Router>
  );
}

export default App;
